import { CardData } from './Card';
import Cards from './Cards';
import PlanPicker from './PlanPicker';
import PRICES from './prices';
import { ColoredText, Layout } from './ui';
import { useTrackProductViewed } from './use-track-view';
import { getDiscountCode } from 'utils/cookies';
import useSearchParams from 'v1/hooks/use-search-params';
import { Box } from 'v1/ui';

export default function Upgrade() {
  useTrackProductViewed();
  const searchParams = useSearchParams();
  const isMagicFill = searchParams.refLink === 'magicFill';
  const cards = getCards(isMagicFill);

  return (
    <Layout>
      <PlanPicker
        heading={getHeading(isMagicFill)}
        subtext={getSubtext(isMagicFill)}
        prices={getPrices()}
        defaultPriceId={getDefaultPriceId()}
        numberOfCards={cards.length}
      />
      <Cards cards={cards} />
    </Layout>
  );
}

function getPrices() {
  return [PRICES['monthly-19'], PRICES['quarterly-29'], PRICES['yearly-69']];
}

function getDefaultPriceId() {
  return PRICES['quarterly-29'].id;
}

function getCards(isMagicFill: boolean): CardData[] {
  if (getDiscountCode() === 'INDIA') {
    return [
      {
        bgColor: '#FB1064',
        textColor: 'white',
        title: 'Get 75% off. Use code INDIA at checkout.',
        imgId: 'sale_mpz0yz',
        text: 'This is a special offer for residents of India to make Standard Resume more affordable.',
      },
      ...defaultCards(),
    ];
  } else if (isMagicFill) {
    let cards = defaultCards();
    // Remove the PDF downloads card
    cards.shift();
    cards = [
      {
        bgColor: '#8B17FF',
        textColor: 'white',
        title: 'Magic Fill your resume content',
        imgId: 'magicfill_ngc1mo',
        text: 'We’ll auto fill your resume with information from LinkedIn and other social profiles.',
      },
      ...cards,
    ];
    // Change hiring manager bg color so its not the same as magic fill
    cards[1].bgColor = '#EF27E7';
    return cards;
  } else {
    return defaultCards();
  }
}

function defaultCards(): CardData[] {
  return [
    {
      bgColor: '#EF27E7',
      textColor: 'white',
      title: 'Unlimited PDF downloads',
      imgId: 'pdf-download_i3b00k',
      text: 'Get unlimited PDF downloads for all of your resumes and all of our templates.',
    },
    {
      bgColor: '#8B17FF',
      textColor: 'white',
      title: 'Hiring manager approved templates',
      imgId: 'hiring-manager_ad2iic',
      text: 'We’ve worked with hiring managers to design and review our templates so you can apply with confidence.',
    },
    {
      bgColor: '#fff',
      textColor: '#2A3FFB',
      title: '32 point resume reviews with suggestions',
      imgId: 'resume-review_xazq0o',
      text: 'Get a comprehensive review of your resume along with actionable tips and suggestions.',
    },
    {
      bgImgId: 'bg-ats_kvn3hq',
      textColor: 'white',
      title: 'ATS compatible templates',
      imgId: 'ats-compatible_n7qfot',
      text: 'Our templates are optimized to help you get past applicant tracking systems.',
    },
    {
      bgColor: '#FF8080',
      textColor: 'white',
      title: 'Support a small team',
      imgId: 'team_qwr27i',
      text: 'Standard Resume was designed and built by Sinan, Sari, and Riley.',
    },
    {
      bgImgId: 'bg-analytics_oscnib',
      textColor: 'white',
      title: 'View tracking & analytics',
      imgId: 'analytics_nlzo0h',
      text: 'Know when your resume has been read so you can follow up at the perfect time.',
    },
    {
      bgColor: '#000',
      textColor: 'white',
      title: 'White labeled web resumes',
      imgId: 'white-label_llsorf',
      text: 'With Pro, you have the option to remove the Standard Resume branding from your web resume.',
    },
    {
      bgColor: '#33A65A',
      textColor: 'white',
      title: 'Custom web resume URLs',
      imgId: 'url_urhbfi',
      text: 'Choose a personal URL for your web resume to give it that professional touch.',
    },
  ];
}

function getHeading(isMagicFill: boolean) {
  if (isMagicFill) {
    return (
      <div>
        Upgrade to edit your{' '}
        <ColoredText color="#8E00FE">Magic Fill</ColoredText> resume
      </div>
    );
  }
  return (
    <>
      Get more interviews. <br />
      Upgrade to <ColoredText color="blue">Pro</ColoredText>.
    </>
  );
}

function getSubtext(isMagicFill: boolean) {
  if (isMagicFill) {
    return (
      <div>
        Upgrading to Pro gives you everything you need to make an impressive
        resume in no time.
        <Box as="ul" sx={{ pl: 24, mt: 3 }}>
          <Box as="li" sx={{ mb: '4px' }}>
            Start editing your Magic Fill resume
          </Box>
          <Box as="li" sx={{ mb: '4px' }}>
            Choose from 12 impressive templates
          </Box>
          <Box as="li" sx={{ mb: '4px' }}>
            Check your resume with our AI resume review
          </Box>
          <Box as="li" sx={{ mb: '4px' }}>
            Download a PDF or create a web resume
          </Box>
          <Box as="li" sx={{ mb: '4px' }}>
            Duplicate & tailor it for other applications
          </Box>
        </Box>
      </div>
    );
  } else {
    return '';
  }
}
